import VueSplide from '@splidejs/vue-splide';
import Vue from 'vue';

Vue.use(VueSplide);
